import revertTitle from "./revertTitle";

const setLocation = (lat, lng) => {

  // @TODO - validate lat and lng values

  document.title = 'setlocation_' + lat + '_' + lng;
  revertTitle();
};

export default setLocation;
